import { makeRemoteFiscalNote } from "../../../../../../main/factories/usecases/fiscal-note/remote-fiscal-note-factory";

const fetchFiscalNoteDocument = async (docId: number): Promise<Blob> =>
  makeRemoteFiscalNote().preview({
    id: docId,
    type: "pdf",
  });

export default fetchFiscalNoteDocument;
